import client from './client'

const getAllCredentials = () => client.get('/app-connections')

const createCredential = (body) => client.post(`/app-connections`, body)

const getCredentialsByName = (componentCredentialName) => client.get(`/credentials?credentialName=${componentCredentialName}`)

// const getAllComponentsCredentials = () => client.get('/components-credentials')

// const getSpecificCredential = (id) => client.get(`/credentials/${id}`)

const getSpecificComponentCredential = (name) => client.get(`/components-credentials/${name}`)

// const updateCredential = (id, body) => client.put(`/credentials/${id}`, body)

// const deleteCredential = (id) => client.delete(`/credentials/${id}`)

export default {
    getAllCredentials,
    createCredential,
    getCredentialsByName,
    // getAllComponentsCredentials,
    // getSpecificCredential,
    getSpecificComponentCredential,
    // updateCredential,
    // deleteCredential
}
